// extracted by mini-css-extract-plugin
module.exports = {"navContainer":"ProfileMenu_navContainer__lr05_","menuItem":"ProfileMenu_menuItem__KwucF"};